// extracted by mini-css-extract-plugin
export default {"root":"address-notifier_root__nl_ma"};